import { Field } from '@k2/common/k2-forms-state/types';

export function multiOptionsFormatter(field: Field): string {
  const options = field.attributes.valueOptions;
  const values = field.control.value || [];

  return values
    .map(value => {
      const selected = options.find(option => option.id === value);
      return selected.value;
    })
    .join('\n');
}
